export const isGoodfyndSitesPreview = (host?: string) => {
  const path = host || global?.window?.location?.host;
  return !path?.includes('goodfynd.com') && path?.includes('preview.');
};

export const getPreviewUrl = (
  host: string,
  protocol: string = 'https'
): string => {
  // Build preview host
  let previewHost: string;
  const isGoodfyndSiteHost = host.includes('.goodfynd.site');

  if (isGoodfyndSiteHost) {
    // Insert .preview after subdomain: vendor.goodfynd.site -> vendor.preview.goodfynd.site
    const parts = host.split('.');
    previewHost = `${parts[0]}.preview.${parts.slice(1).join('.')}`;
  } else {
    // Add preview. as subdomain: example.com -> preview.example.com
    previewHost = `preview.${host}`;
  }

  return `${protocol.replace(':', '')}://${previewHost}`;
};
